// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4940":"27d5aaa0a92b8360","5670":"28e99abd6c39ea52","9116":"7f430e9d50aed760","9721":"a498ec6b551ba9b0"}[chunkId] + ".css";
};